<template>
</template>

<script>
  import { mapState } from 'vuex'
  import c3 from 'c3'
  import d3 from 'd3'
  import '@/assets/chart/c3.min.css'
  import * as func from '@/assets/chart/chartFunc'

  var chart
  export default {
    name: 'ctrChart',
    props: {
      chartData: Array,
      chartName: String,
      ctrAvg: String
    },
    methods: {
      formatCheck (data) {
        if (data < 0.1) {
          return d3.format('.3f')
        } else {
          return d3.format('.2f')
        }
      },
      drawChart () {
        if (this.chartData === undefined || this.chartData.length === 0) return
        let data = this.chartData
        let tooltipFormat = d3.format(',r')

        let id = '#chart'
        let axisInfo = func.getAxisRange(data)
        let y1Range = func.getYRange(axisInfo.y1Min, axisInfo.y1Max, true) // y axis의 range
        let y2Range = func.getYRange(axisInfo.y2Min, axisInfo.y2Max, false) // y axis의 range
        let avgCtr = this.ctrAvg

        d3.select('#chartContainer').append('div')
          .attr('id', 'chartWrap')
        d3.select('#chartWrap').append('div')
          .attr('class', 'chartTitle').text(this.chartName)
        d3.select('#chartWrap')
        .append('div').attr('id', 'chart')
        .attr('class', 'chart')

        chart = c3.generate({
          bindto: id,
          size: {
            height: 250
          },
          data: {
            json: data,
            keys: {
              value: ['imp_cnt', 'ctr']
            },
            types: {
              imp_cnt: 'bar',
              ctr: 'spline'
            },
            axes: {
              imp_cnt: 'y',
              ctr: 'y2'
            },
            names: {
              imp_cnt: '노출수',
              ctr: '클릭률(%)'
            },
            color: function (color, d) {
              // d will be 'id' when called for legends
              // #0bb4c9
              if (d === 'ctr') {
                return d === 'ctr' ? '#ea5c58' : '#4cdbec'
              }
              return d.id === 'ctr' ? '#ea5c58' : '#4cdbec'
            }
          },
          bar: {
            width: {
              ratio: 0.5,
              max: 80 // max-width
            }
          },
          point: {
            r: 3,
            focus: {
              expand: {
                r: 4
              }
            }
          },
          axis: {
            x: {
              type: 'category',
              categories: axisInfo.xCategory,
              tick: {
                outer: false,
                centered: true,
                multiline: false,
                culling: {
                  max: ((data.length / 5) + 1) > 7 ? 7 : ((data.length / 5) + 1) // 표시할 x axis수
                },
                format: function (x) { return func.parse(axisInfo.xCategory[x]) }
              }
            },
            y: {
              max: y1Range.max,
              min: y1Range.min,
              tick: {
                values: func.getY1Values(y1Range.min, y1Range.max, axisInfo.imp),
                format: d3.format(',.2r'),
                outer: false
              },
              padding: {
                bottom: 0
              }
            },
            y2: {
              show: true,
              max: y2Range.max,
              min: y2Range.min,
              tick: {
                values: func.getY2Values(y2Range.min, y2Range.max, axisInfo.ctr),
                format: this.formatCheck(y2Range.max),
                outer: false
              },
              padding: {
                bottom: 0
              }
            }
          },
          tooltip: {
            format: {
              value: function (value, ratio, id) {
                return id === 'imp_cnt' ? tooltipFormat(value) : value.toFixed(2)
              }
            },
            order: function (t1, t2) {
              return t1.id < t2.id
            }
          },
          grid: {
            y: {
              show: true,
              lines: [
                {value: avgCtr, axis: 'y2', class: 'avgCtr', text: 'ctr 평균 : ' + avgCtr + '%'}
              ]
            }
          },
          legend: {
            show: false
          }
        })

        d3.select('#chartWrap').insert('div', '.chart')
        .attr('class', 'legend').append('div').attr('class', 'legend_box_wrap')
        .selectAll('div').data(['imp_cnt', 'ctr'])
        .enter().append('div')
        .attr('data-id', function (id) { return id })
        .attr('class', 'legend_box')
        .html(function (id) {
          return id === 'imp_cnt'
          ? '<img src="static/img/imp.png" class="imp_img"/>노출수'
          : '<img src="static/img/ctr.png" class="ctr_img"/>클릭률 (%)'
        })
        .each(function (id) {
          if (id === 'imp_cnt') d3.select(this).style('border-right', '10px solid #ffffff')
          d3.select(this).style('font-weight', '500')
        })
        .on('mouseover', function (id) {
          chart.focus(id)
        })
        .on('mouseout', function (id) {
          chart.revert()
        })
        .on('click', function (id) {
          chart.toggle(id)
        })
      }
    },
    computed: {
      ...mapState({
        campaignInfo: state => state.campaign.campaignInfo
      })
    },
    mounted () {
      this.drawChart()
    },
    watch: {
      chartData (val) {
        if (chart === undefined) {
          this.drawChart()
          return
        }
        let p = document.getElementById('chartContainer')
        let c = document.getElementById('chartWrap')
        chart.destroy()
        if (c) p.removeChild(c)
        this.drawChart()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CtrChart.vue?5f9647bd